import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { Button, Icon, Modal } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { AttachmentsList, LogsTable } from "modules/AppointmentDetails/components/Logs/components";
import { useAttachments, useLogs } from "modules/AppointmentDetails/components/Logs/hooks";
import "modules/AppointmentDetails/components/Logs/Logs.scss";

type LogsProps = {
  appointment_id: number;
};

export const Logs = ({ appointment_id }: LogsProps) => {
  const { t } = useTranslation();

  const canListAttachments = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.AppointmentNotesURLs);

  const [showLogs, setShowLogs] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);

  const { data: logs = [], isError: logsError, refetch: refetchLogs } = useLogs(appointment_id);
  const { data: attachments = [], isError: attachmentsError, refetch: refetchAttachments } = useAttachments(appointment_id);

  const handleOpenLogsModal = () => {
    refetchLogs();
    if (canListAttachments) refetchAttachments();
    setShowLogs(true);
  };

  const handleCloseLogsModal = () => setShowLogs(false);

  if (logsError) toast.error(t("v8_something_went_wrong", "Something went wrong"), { containerId: "logs-modal-toast" });

  return (
    <>
      <Button className="-appointment-status" size="small" onClick={handleOpenLogsModal}>
        {t("v8_logs", "LOGS")}
      </Button>

      <Modal size="large" open={showLogs} onClose={handleCloseLogsModal} dimmer="blurring" closeOnDimmerClick className="Logs">
        <Modal.Header className="logs-title">
          <p className="log-modal-title">{t("v8_appointment_detail_log", "Appointment Detail Log")}</p>
          <div className="car-check">
            {attachments.length ? (
              <Button secondary color="blue" size="small" onClick={() => setShowAttachments(true)}>
                {t("v8_car_check_files", "Car check files")}
              </Button>
            ) : null}
            <Button className="-appointment-status" size="small" onClick={handleCloseLogsModal}>
              <Icon className="xmark grey" size="big" />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <LogsTable logs={logs} />
        </Modal.Content>
        <ToastContainer containerId="logs-modal-toast" position="top-right" autoClose={5000} closeOnClick draggable theme="light" />
      </Modal>
      <AttachmentsList close={() => setShowAttachments(false)} showAttachments={showAttachments} attachments={attachments} hasAttachmentsError={attachmentsError} />
    </>
  );
};
